import styled,
 {keyframes} from 'styled-components';
import {
        AiOutlineInstagram,
        AiOutlineFacebook,
        AiOutlineTwitter,
        AiOutlineYoutube,
        AiOutlineArrowUp,
        AiOutlineArrowLeft,
        AiOutlineArrowRight,
    } from 'react-icons/ai';


    //cabeçalho
export const MostraCabecalho = keyframes`
    from{
        opacity:0;
        transform:translateY(-100%);
    }
    to{
        opacity:1;
        transform:translateY(0%);
    }

`

export const DivCabecalho = styled.div`
    display:grid;
    grid-template-columns:30vw 30vw 30vw;
    width:100%;
    height:150px;
    padding:0 20px;
    justify-content:space-between;
    align-items:center;
    animation:${MostraCabecalho} 1500ms backwards;

`
export const IconAiOutlineInstagram = styled(AiOutlineInstagram)`
    font-size:30px;
`
export const IconAiOutlineFacebook = styled(AiOutlineFacebook)`
    font-size:30px;
`
export const IconAiOutlineTwitter = styled(AiOutlineTwitter)`
    font-size:30px;
`
export const IconAiOutlineYoutube = styled(AiOutlineYoutube)`
    font-size:30px;
`
export const IconAiOutlineArrowUp = styled(AiOutlineArrowUp)`
    font-size:30px;
`
export const IconAiOutlineArrowLeft = styled(AiOutlineArrowLeft)`
    font-size:30px;
    @media(max-width:800px){
        font-size:15px;
    }
`
export const IconAiOutlineArrowRight = styled(AiOutlineArrowRight)`
    font-size:30px;
    @media(max-width:800px){
        font-size:15px;
    }
`
export const UlOpcoesDoMenu = styled.ul`
    display:inline-flex;
    list-style:none;
    width:fit-content;
`

export const OpcoesMenu = styled.li`
    margin:0 20px;
    font-weight:bolder;
    cursor:pointer;
    font-size:14px;
    transition:0.5s;

    :hover{
        transform:translateY(-4px);
        text-decoration:underline;
        color:rgba(102, 100, 100,1);
        font-weight:bolder;
    }
`
export const UlMenuRedesSociais = styled.ul`
    display:inline-flex;
    list-style:none;
    width:fit-content;
    place-self:center;

    > li{
        margin:0 20px;
        :hover{
            cursor:pointer;
        }
    }
`

export const DivNomeDoBlog = styled.div`
    text-align:center;
    font-size:40px;
    font-weight:bolder;
    width:100%;
    place-self:center;
`

//cabeçalho
export const DivPost = styled.div`
border: 1px solid #eeeeee;
border-radius:5px;
background:#fff;
width:350px;
margin:20px;
overflow:hidden;
:hover{
      box-shadow:0 0.625rem 0.875rem -0.3125rem #e0e0e0;
      transform:scale(1.08);
      transition:transform 0.5s;

  }
`
export const DivLink = styled.div`
>a{

}

`

export const DivImg = styled.div`


`
export const ImgPost = styled.img`
border-radius:5px 5px 0 0;

`
export const MyBtn = styled.button`
    width:60px;
    height:60px;
    display: ${props=>props.display}; /* Hidden by default */
    position: fixed; /* Fixed/sticky position */
    bottom: 20px; /* Place the button at the bottom of the page */
    right: 30px; /* Place the button 30px from the right */
    z-index: 3; /* Make sure it does not overlap */
    border: none; /* Remove borders */
    outline: none; /* Remove outline */
    background-color: #333333; /* Set a background color */
    color: #fff; /* Text color */
    cursor: pointer; /* Add a mouse pointer on hover */
    padding: 15px; /* Some padding */
    border-radius: 100px; /* Rounded corners */
    font-size: 18px; /* Increase font size */
    :hover {
    background-color: #333333; /* Add a dark-grey background on hover */
}
`

export const DivPrincipal = styled.div`
    overflow:auto;
    background:#fff;
    width:100%;
    height:${props=>props.heightReal}px;
    scroll-behavior:smooth;

`

export const DivFlexPostsBlog = styled.div`
    display:flex;
    flex-direction:row;
    flex-wrap:wrap;
    width:100%;
    justify-content:space-evenly;
    text-align:center;
`
